import { render } from "./PrivacyChart.vue?vue&type=template&id=69d9808c&scoped=true"
import script from "./PrivacyChart.vue?vue&type=script&lang=js"
export * from "./PrivacyChart.vue?vue&type=script&lang=js"

import "./PrivacyChart.vue?vue&type=style&index=0&id=69d9808c&scoped=true&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d9808c"]])

export default __exports__